
import { config } from '../../Config';

export const Footer = () => {
    return (
        <footer style={{
            color: '#000',
            textAlign: 'center',
            fontSize: '12px',
            padding: '0px 0',
            position: 'absolute', 
            bottom: '5px', 
            left: '50%', 
            transform: 'translateX(-50%)', 
            width: 'max-content' 
        }}>
            {config.disclaimer || 'DoAssist-generated responses may be inaccurate. Verify important details.'}
        </footer>
    );
};

